import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelText as _vModelText } from "vue"
import _imports_0 from '@/assets/filter.svg'
import _imports_1 from '@/assets/filterIcon_Disabled.svg'
import _imports_2 from '@/assets/cancel.svg'
import _imports_3 from '@/assets/deleteIcon.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "flex justify-between items-center h-8" }
const _hoisted_4 = { class: "flex items-center gap-3" }
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_6 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_7 = { class: "mainContainer tabStructure w-full bg-white border rounded-sm mt-5 px-5 pt-5 pb-3 border-lightgrey" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_10 = {
  key: 1,
  class: "w-full"
}
const _hoisted_11 = {
  key: 0,
  class: "noScrollbar tabControlMapping"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  class: "noScrollbar tabControlMapping businesssPopup"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 2,
  class: "noScrollbar tabControlMapping"
}
const _hoisted_16 = { disabled: true }
const _hoisted_17 = { class: "statuscontainer" }
const _hoisted_18 = { class: "formcontainer flex flex-col" }
const _hoisted_19 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_20 = { class: "w-6/12" }
const _hoisted_21 = { class: "text-sm" }
const _hoisted_22 = { class: "w-6/12 leftspacing" }
const _hoisted_23 = { class: "text-sm" }
const _hoisted_24 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_25 = { class: "w-6/12" }
const _hoisted_26 = { class: "text-sm" }
const _hoisted_27 = { class: "w-6/12 leftspacing" }
const _hoisted_28 = { class: "text-sm" }
const _hoisted_29 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_30 = { class: "w-6/12" }
const _hoisted_31 = { class: "text-sm" }
const _hoisted_32 = { class: "w-6/12" }
const _hoisted_33 = { class: "text-sm leftspacing" }
const _hoisted_34 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_35 = { class: "w-6/12" }
const _hoisted_36 = { class: "text-sm" }
const _hoisted_37 = { class: "w-6/12" }
const _hoisted_38 = { class: "text-sm leftspacing" }
const _hoisted_39 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_40 = { class: "w-full" }
const _hoisted_41 = { class: "text-sm" }
const _hoisted_42 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_43 = { class: "w-full" }
const _hoisted_44 = { class: "text-sm" }
const _hoisted_45 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_46 = { class: "w-full" }
const _hoisted_47 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_48 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_49 = {
  key: 3,
  class: "noScrollbar tabControlMapping"
}
const _hoisted_50 = {
  key: 0,
  class: "tableCornerRadius"
}
const _hoisted_51 = { class: "table-container" }
const _hoisted_52 = {
  class: "header cursor-pointer",
  style: {"width":"5%"}
}
const _hoisted_53 = { class: "flex items-center w-4" }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = { class: "flex items-center w-28" }
const _hoisted_56 = { class: "flex items-center w-44" }
const _hoisted_57 = { class: "flex items-center w-32" }
const _hoisted_58 = { class: "flex items-center w-28" }
const _hoisted_59 = { class: "flex items-center w-28" }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = ["value"]
const _hoisted_62 = { class: "searchRow" }
const _hoisted_63 = { class: "searchRow" }
const _hoisted_64 = { class: "searchRow" }
const _hoisted_65 = ["value"]
const _hoisted_66 = { class: "searchRow" }
const _hoisted_67 = ["value"]
const _hoisted_68 = { key: 0 }
const _hoisted_69 = {
  key: 1,
  class: "nonEmptyTable"
}
const _hoisted_70 = ["onClick"]
const _hoisted_71 = ["value", "onChange"]
const _hoisted_72 = ["onMousemove"]
const _hoisted_73 = { class: "table-ellipsis" }
const _hoisted_74 = ["onMousemove"]
const _hoisted_75 = { class: "table-ellipsis" }
const _hoisted_76 = ["onMousemove"]
const _hoisted_77 = { key: 0 }
const _hoisted_78 = { key: 1 }
const _hoisted_79 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_80 = { class: "flex flex-col h-full" }
const _hoisted_81 = { class: "flex-1 overflow-auto" }
const _hoisted_82 = { class: "popup-business" }
const _hoisted_83 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_84 = { class: "formcontainer flex flex-col" }
const _hoisted_85 = { class: "w-full upperspacing" }
const _hoisted_86 = { key: 0 }
const _hoisted_87 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_88 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_89 = { key: 1 }
const _hoisted_90 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_91 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_92 = { class: "row flex flex-row w-full" }
const _hoisted_93 = { class: "w-6/12" }
const _hoisted_94 = { key: 0 }
const _hoisted_95 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_96 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_97 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_98 = { class: "w-3/6 leftspacing" }
const _hoisted_99 = { key: 0 }
const _hoisted_100 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_101 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_102 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_103 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_104 = { class: "w-full" }
const _hoisted_105 = { key: 0 }
const _hoisted_106 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_107 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_108 = { key: 1 }
const _hoisted_109 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_110 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_111 = { class: "row flex flex-row w-full" }
const _hoisted_112 = { class: "w-6/12" }
const _hoisted_113 = { key: 0 }
const _hoisted_114 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_115 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_116 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_117 = { class: "w-6/12 leftspacing" }
const _hoisted_118 = { key: 0 }
const _hoisted_119 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_120 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_121 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_122 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_123 = { class: "w-full" }
const _hoisted_124 = { key: 0 }
const _hoisted_125 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_126 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_127 = { key: 1 }
const _hoisted_128 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_129 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_130 = { class: "row flex flex-row w-full" }
const _hoisted_131 = { class: "w-6/12" }
const _hoisted_132 = { key: 0 }
const _hoisted_133 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_134 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_135 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_136 = { class: "w-6/12 leftspacing" }
const _hoisted_137 = { key: 0 }
const _hoisted_138 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_139 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_140 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_141 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_142 = { class: "row flex flex-row w-full" }
const _hoisted_143 = { class: "w-6/12" }
const _hoisted_144 = { key: 0 }
const _hoisted_145 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_146 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_147 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_148 = { class: "w-6/12 leftspacing" }
const _hoisted_149 = { key: 0 }
const _hoisted_150 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_151 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_152 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_153 = { class: "formcontainer" }
const _hoisted_154 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_155 = { class: "w-3/6" }
const _hoisted_156 = { key: 0 }
const _hoisted_157 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_158 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_159 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_160 = { class: "w-3/6 leftspacing" }
const _hoisted_161 = { key: 0 }
const _hoisted_162 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_163 = { key: 0 }
const _hoisted_164 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_165 = ["disabled"]
const _hoisted_166 = ["disabled"]
const _hoisted_167 = ["disabled"]
const _hoisted_168 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_169 = { class: "flex flex-col h-full" }
const _hoisted_170 = { class: "flex-1 overflow-auto" }
const _hoisted_171 = { class: "popup-business" }
const _hoisted_172 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_173 = { class: "formcontainer flex flex-col" }
const _hoisted_174 = { class: "w-full upperspacing" }
const _hoisted_175 = { class: "text-sm" }
const _hoisted_176 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_177 = { class: "row flex flex-row w-full" }
const _hoisted_178 = { class: "w-6/12" }
const _hoisted_179 = { class: "text-sm" }
const _hoisted_180 = { class: "w-3/6 leftspacing" }
const _hoisted_181 = { class: "text-sm" }
const _hoisted_182 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_183 = { class: "w-full" }
const _hoisted_184 = { class: "text-sm" }
const _hoisted_185 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_186 = { class: "row flex flex-row w-full" }
const _hoisted_187 = { class: "w-6/12" }
const _hoisted_188 = { class: "text-sm" }
const _hoisted_189 = { class: "w-6/12 leftspacing" }
const _hoisted_190 = { class: "text-sm" }
const _hoisted_191 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_192 = { class: "w-full" }
const _hoisted_193 = { class: "text-sm" }
const _hoisted_194 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_195 = { class: "row flex flex-row w-full" }
const _hoisted_196 = { class: "w-6/12" }
const _hoisted_197 = { class: "text-sm" }
const _hoisted_198 = { class: "w-6/12 leftspacing" }
const _hoisted_199 = { class: "text-sm" }
const _hoisted_200 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_201 = { class: "row flex flex-row w-full" }
const _hoisted_202 = { class: "w-6/12" }
const _hoisted_203 = { class: "text-sm" }
const _hoisted_204 = { class: "w-6/12 leftspacing" }
const _hoisted_205 = { class: "text-sm" }
const _hoisted_206 = { class: "formcontainer" }
const _hoisted_207 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_208 = { class: "w-3/6" }
const _hoisted_209 = { class: "text-sm" }
const _hoisted_210 = { class: "w-3/6 leftspacing" }
const _hoisted_211 = { class: "text-sm" }
const _hoisted_212 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_213 = { class: "flex flex-col h-full" }
const _hoisted_214 = { class: "flex-1 overflow-auto" }
const _hoisted_215 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_216 = { class: "formcontainer flex flex-col" }
const _hoisted_217 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_218 = {
  key: 0,
  class: "w-full"
}
const _hoisted_219 = { class: "text-sm" }
const _hoisted_220 = {
  key: 1,
  class: "w-full"
}
const _hoisted_221 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_222 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_223 = { class: "w-full upperspacing" }
const _hoisted_224 = {
  key: 0,
  class: "w-full"
}
const _hoisted_225 = { class: "text-sm" }
const _hoisted_226 = {
  key: 1,
  class: "w-full"
}
const _hoisted_227 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_228 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_229 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_230 = {
  key: 0,
  class: "w-6/12"
}
const _hoisted_231 = { class: "text-sm" }
const _hoisted_232 = {
  key: 1,
  class: "w-6/12"
}
const _hoisted_233 = { key: 0 }
const _hoisted_234 = { class: "text-sm" }
const _hoisted_235 = {
  key: 3,
  class: "w-6/12 leftspacing"
}
const _hoisted_236 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_237 = {
  key: 0,
  class: "w-6/12"
}
const _hoisted_238 = { key: 0 }
const _hoisted_239 = { class: "text-sm" }
const _hoisted_240 = {
  key: 1,
  class: "w-6/12"
}
const _hoisted_241 = { key: 0 }
const _hoisted_242 = { class: "text-sm" }
const _hoisted_243 = {
  key: 3,
  class: "w-6/12 leftspacing"
}
const _hoisted_244 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_245 = {
  key: 0,
  class: "w-6/12"
}
const _hoisted_246 = { key: 0 }
const _hoisted_247 = { class: "text-sm" }
const _hoisted_248 = {
  key: 1,
  class: "w-6/12"
}
const _hoisted_249 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_250 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_251 = {
  key: 2,
  class: "w-6/12"
}
const _hoisted_252 = { key: 0 }
const _hoisted_253 = { class: "text-sm" }
const _hoisted_254 = { key: 0 }
const _hoisted_255 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_256 = {
  key: 1,
  class: "mx-4 border-b border-solid border-lightgrey"
}
const _hoisted_257 = {
  key: 0,
  class: "statuscontainer p-2 w-11/12 my-2 border-solid border border-lightgrey rounded"
}
const _hoisted_258 = { class: "text-sm font-light text-gray bg-white" }
const _hoisted_259 = { class: "text-sm flex flex-row items-center justify-between" }
const _hoisted_260 = { class: "flex justify-center items-center" }
const _hoisted_261 = ["onClick"]
const _hoisted_262 = {
  key: 0,
  class: "buttonposition flex justify-center items-center my-4 mx-0"
}
const _hoisted_263 = { class: "flex flex-col h-full" }
const _hoisted_264 = { class: "flex-1 overflow-auto" }
const _hoisted_265 = { class: "border-0 rounded relative flex flex-col w-full bg-white risksAcceptance h-screen" }
const _hoisted_266 = { class: "flex items-center justify-between p-3 rounded popupheadingcontainer" }
const _hoisted_267 = { key: 0 }
const _hoisted_268 = { key: 1 }
const _hoisted_269 = { key: 2 }
const _hoisted_270 = { key: 3 }
const _hoisted_271 = { key: 4 }
const _hoisted_272 = { class: "impactcontainer popupbodycontainer" }
const _hoisted_273 = { class: "formcontainer flex flex-col" }
const _hoisted_274 = { class: "row flex flex-col" }
const _hoisted_275 = { class: "upperspacing" }
const _hoisted_276 = { class: "text-xs flex flex-wrap" }
const _hoisted_277 = { class: "w-full upperspacing" }
const _hoisted_278 = {
  key: 0,
  class: "controllabel"
}
const _hoisted_279 = {
  key: 1,
  class: "controllabel"
}
const _hoisted_280 = {
  key: 2,
  class: "controllabel"
}
const _hoisted_281 = {
  key: 3,
  class: "controllabel"
}
const _hoisted_282 = {
  key: 4,
  class: "controllabel"
}
const _hoisted_283 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_284 = ["disabled"]
const _hoisted_285 = ["disabled"]
const _hoisted_286 = ["disabled"]
const _hoisted_287 = ["disabled"]
const _hoisted_288 = ["disabled"]
const _hoisted_289 = ["disabled"]
const _hoisted_290 = { class: "flex items-center justify-between py-4 px-4 rounded" }
const _hoisted_291 = { class: "flex flex-col h-full" }
const _hoisted_292 = { class: "flex-1 overflow-auto p-4 space-y-2" }
const _hoisted_293 = { class: "w-full" }
const _hoisted_294 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_295 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_296 = { class: "w-1/2" }
const _hoisted_297 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_298 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_299 = { key: 1 }
const _hoisted_300 = { class: "row flex flex-row w-full" }
const _hoisted_301 = { class: "w-full" }
const _hoisted_302 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_303 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_304 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_305 = ["disabled"]
const _hoisted_306 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumb = _resolveComponent("breadCrumb")!
  const _component_Tab = _resolveComponent("Tab")!
  const _component_TabList = _resolveComponent("TabList")!
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_newTable = _resolveComponent("newTable")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabPanels = _resolveComponent("TabPanels")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Select = _resolveComponent("Select")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_breadCrumb, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.businesss.entityDisplayName), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.selectedIndex == 3 && _ctx.systemAssesmentList.length != 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createAssesmentTask())),
              class: _normalizeClass(_ctx.checkedItems.length > 0 ? 'btnprimary' : 'btndisabled pointer-events-none')
            }, "Create", 2))
          : _createCommentVNode("", true),
        (_ctx.selectedIndex == 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btnprimary flex items-center",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addRiskForOrganiztaion()))
            }, "Add"))
          : _createCommentVNode("", true),
        (_ctx.selectedIndex == 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              class: "btnprimary flex items-center",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addInformationForProcess()))
            }, "Add"))
          : _createCommentVNode("", true),
        (_ctx.selectedIndex != 2)
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              class: _normalizeClass([(_ctx.selectedIndex == 0 && _ctx.risksDataJson.length != 0) || (_ctx.selectedIndex == 1 && _ctx.mappedInfoForProcess.length != 0) || (_ctx.selectedIndex == 3 && _ctx.systemAssesmentList.length != 0) ? 'filterButton' : 'btndisabled pointer-events-none', "flex"]),
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
            }, [
              ((_ctx.selectedIndex == 0 && _ctx.risksDataJson.length != 0) || (_ctx.selectedIndex == 1 && _ctx.mappedInfoForProcess.length != 0) || (_ctx.selectedIndex == 3 && _ctx.systemAssesmentList.length != 0))
                ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                : (_openBlock(), _createElementBlock("img", _hoisted_6)),
              _cache[78] || (_cache[78] = _createTextVNode(" Filters "))
            ], 2))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_Tabs, {
        value: _ctx.selectedIndex,
        "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.selectedIndex) = $event)),
        scrollable: "",
        class: "heightFixing pr-5"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_TabList, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleTabs, (tab) => {
                  return (_openBlock(), _createBlock(_component_Tab, {
                    key: tab.id,
                    value: tab.id,
                    onClick: ($event: any) => (_ctx.toggleTabs(tab))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tab.displayName), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_TabPanels, { class: "overflow-auto hide-scrollbar" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleTabs, (tab) => {
                return (_openBlock(), _createBlock(_component_TabPanel, {
                  key: tab.id,
                  value: tab.id
                }, {
                  default: _withCtx(() => [
                    (_ctx.dataLoading == true)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_dots_loader)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          (_ctx.selectedIndex == 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createVNode(_component_newTable, {
                                  tableRowData: _ctx.risksDataJson,
                                  headersData: _ctx.riskHeaders,
                                  openPopup: true,
                                  navigate: false,
                                  loadData: _ctx.dataLoading
                                }, null, 8, ["tableRowData", "headersData", "loadData"]),
                                (_ctx.toolTipActive)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                      _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (tab.id == 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createVNode(_component_newTable, {
                                  tableRowData: _ctx.mappedInfoForProcess,
                                  headersData: _ctx.informationHeaders,
                                  openPopup: true,
                                  loadData: _ctx.dataLoading
                                }, null, 8, ["tableRowData", "headersData", "loadData"]),
                                (_ctx.toolTipActive)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                      _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (tab.id == 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createElementVNode("fieldset", _hoisted_16, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_17, [
                                      _createElementVNode("div", _hoisted_18, [
                                        _createElementVNode("div", _hoisted_19, [
                                          _createElementVNode("div", _hoisted_20, [
                                            _cache[79] || (_cache[79] = _createElementVNode("label", { class: "controllabel" }, "Display Name", -1)),
                                            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.businesss.entityDisplayName ? _ctx.businesss.entityDisplayName : 'N/A'), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_22, [
                                            _cache[80] || (_cache[80] = _createElementVNode("label", { class: "controllabel" }, "Legal Name", -1)),
                                            _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.businesss.entityName ? _ctx.businesss.entityName : 'N/A'), 1)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_24, [
                                          _createElementVNode("div", _hoisted_25, [
                                            _cache[81] || (_cache[81] = _createElementVNode("label", { class: "controllabel" }, "Type", -1)),
                                            _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.orgType.find(option => option.id === _ctx.businesss.entityType)?.value || "-"), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_27, [
                                            _cache[82] || (_cache[82] = _createElementVNode("label", { class: "controllabel" }, "Owner", -1)),
                                            _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.optionsUserArray.find(option => option.value === _ctx.businesss.owner)?.label||'N/A'), 1)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_29, [
                                          _createElementVNode("div", _hoisted_30, [
                                            _cache[83] || (_cache[83] = _createElementVNode("label", { class: "controllabel" }, "Region", -1)),
                                            _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.regionDataArray.find(option => option._id === _ctx.businesss.region)?.region || "N/A"), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_32, [
                                            _cache[84] || (_cache[84] = _createElementVNode("label", { class: "controllabel leftspacing" }, "Country", -1)),
                                            _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.businesss.country ? _ctx.businesss.country : 'N/A'), 1)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_34, [
                                          _createElementVNode("div", _hoisted_35, [
                                            _cache[85] || (_cache[85] = _createElementVNode("label", { class: "controllabel" }, "State", -1)),
                                            _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.businesss.state ? _ctx.businesss.state : 'N/A'), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_37, [
                                            _cache[86] || (_cache[86] = _createElementVNode("label", { class: "controllabel leftspacing" }, "City", -1)),
                                            _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.businesss.city ? _ctx.businesss.city : 'N/A'), 1)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_39, [
                                          _createElementVNode("div", _hoisted_40, [
                                            _cache[87] || (_cache[87] = _createElementVNode("label", { class: "controllabel" }, "PIN Code", -1)),
                                            _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.businesss.zipCode ? _ctx.businesss.zipCode : 'N/A'), 1)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_42, [
                                          _createElementVNode("div", _hoisted_43, [
                                            _cache[88] || (_cache[88] = _createElementVNode("label", { class: "controllabel" }, "Address Line 1", -1)),
                                            _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.businesss.addressLineOne || 'N/A'), 1)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_45, [
                                          _createElementVNode("div", _hoisted_46, [
                                            _cache[89] || (_cache[89] = _createElementVNode("label", { class: "controllabel" }, [
                                              _createTextVNode("Address Line 2 "),
                                              _createElementVNode("span", { class: "text-xs" }, "(Optional)")
                                            ], -1)),
                                            (_ctx.businesss.addressLineTwo)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(_ctx.businesss.addressLineTwo), 1))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString('N/A')))
                                          ])
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (tab.id == 3)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                (_ctx.discovery == false)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                      _createElementVNode("div", _hoisted_51, [
                                        _createElementVNode("table", null, [
                                          _createElementVNode("thead", null, [
                                            _createElementVNode("th", _hoisted_52, [
                                              _createElementVNode("div", _hoisted_53, [
                                                _withDirectives(_createElementVNode("input", {
                                                  type: "checkbox",
                                                  class: "checkbox cursor-pointer",
                                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectAll) = $event)),
                                                  disabled: _ctx.sortedData.length == 0,
                                                  onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectAllOptions($event)))
                                                }, null, 40, _hoisted_54), [
                                                  [_vModelCheckbox, _ctx.selectAll]
                                                ])
                                              ])
                                            ]),
                                            _createElementVNode("th", {
                                              class: "header cursor-pointer",
                                              style: {"width":"5%"},
                                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sort('severity')))
                                            }, [
                                              _createElementVNode("div", _hoisted_55, [
                                                _cache[90] || (_cache[90] = _createElementVNode("div", null, "Severity", -1)),
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["sort cursor-pointer", _ctx.className == 'severity' ? _ctx.classSort : 'opacity-50'])
                                                }, null, 2)
                                              ])
                                            ]),
                                            _createElementVNode("th", {
                                              class: "header cursor-pointer",
                                              style: {"width":"25%"},
                                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sort('risk')))
                                            }, [
                                              _createElementVNode("div", _hoisted_56, [
                                                _cache[91] || (_cache[91] = _createElementVNode("div", null, "Risk", -1)),
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["sort cursor-pointer", _ctx.className == 'risk' ? _ctx.classSort : 'opacity-50'])
                                                }, null, 2)
                                              ])
                                            ]),
                                            _createElementVNode("th", {
                                              class: "header cursor-pointer",
                                              style: {"width":"25%"},
                                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sort('riskCategory')))
                                            }, [
                                              _createElementVNode("div", _hoisted_57, [
                                                _cache[92] || (_cache[92] = _createElementVNode("div", null, "Category", -1)),
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["sort cursor-pointer", _ctx.className == 'riskCategory' ? _ctx.classSort : 'opacity-50'])
                                                }, null, 2)
                                              ])
                                            ]),
                                            _createElementVNode("th", {
                                              class: "header cursor-pointer",
                                              style: {"width":"15%"},
                                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sort('likelihood')))
                                            }, [
                                              _createElementVNode("div", _hoisted_58, [
                                                _cache[93] || (_cache[93] = _createElementVNode("div", { class: "pl-2" }, "Likelihood", -1)),
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["sort cursor-pointer", _ctx.className == 'likelihood' ? _ctx.classSort : 'opacity-50'])
                                                }, null, 2)
                                              ])
                                            ]),
                                            _createElementVNode("th", {
                                              class: "header cursor-pointer",
                                              style: {"width":"15%"},
                                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.sort('likelihood')))
                                            }, [
                                              _createElementVNode("div", _hoisted_59, [
                                                _cache[94] || (_cache[94] = _createElementVNode("div", { class: "pl-2" }, "Overall Impact", -1)),
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["sort cursor-pointer", _ctx.className == 'likelihood' ? _ctx.classSort : 'opacity-50'])
                                                }, null, 2)
                                              ])
                                            ]),
                                            (_ctx.showFilters)
                                              ? (_openBlock(), _createElementBlock("tr", _hoisted_60, [
                                                  _cache[98] || (_cache[98] = _createElementVNode("td", null, null, -1)),
                                                  _createElementVNode("td", null, [
                                                    _withDirectives(_createElementVNode("select", {
                                                      class: _normalizeClass(["widthForSelect", _ctx.filterDummy.severity == '' ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.filterDummy.severity) = $event))
                                                    }, [
                                                      _cache[95] || (_cache[95] = _createElementVNode("option", {
                                                        value: "",
                                                        selected: "",
                                                        disabled: "",
                                                        hidden: ""
                                                      }, "Select", -1)),
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbOverAllImpact, (pair) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                          class: "optionColors",
                                                          key: pair,
                                                          value: pair.value
                                                        }, _toDisplayString(pair.key), 9, _hoisted_61))
                                                      }), 128))
                                                    ], 2), [
                                                      [_vModelSelect, _ctx.filterDummy.severity]
                                                    ])
                                                  ]),
                                                  _createElementVNode("td", _hoisted_62, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      type: "text",
                                                      class: "inputboxStylingForFilter filter-font-size",
                                                      placeholder: "Search",
                                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.filterDummy.risk) = $event))
                                                    }, null, 512), [
                                                      [_vModelText, _ctx.filterDummy.risk]
                                                    ])
                                                  ]),
                                                  _createElementVNode("td", _hoisted_63, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      type: "text",
                                                      class: "inputboxStylingForFilter filter-font-size",
                                                      placeholder: "Search",
                                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.filterDummy.riskCategory) = $event))
                                                    }, null, 512), [
                                                      [_vModelText, _ctx.filterDummy.riskCategory]
                                                    ])
                                                  ]),
                                                  _createElementVNode("td", _hoisted_64, [
                                                    _withDirectives(_createElementVNode("select", {
                                                      class: _normalizeClass(["widthForSelect", _ctx.filterDummy.likelihood == '' ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.filterDummy.likelihood) = $event))
                                                    }, [
                                                      _cache[96] || (_cache[96] = _createElementVNode("option", {
                                                        value: "",
                                                        selected: "",
                                                        disabled: "",
                                                        hidden: ""
                                                      }, "Select", -1)),
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbLikelihood, (pair) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                          class: "optionColors",
                                                          key: pair,
                                                          value: pair.value
                                                        }, _toDisplayString(pair.key), 9, _hoisted_65))
                                                      }), 128))
                                                    ], 2), [
                                                      [_vModelSelect, _ctx.filterDummy.likelihood]
                                                    ])
                                                  ]),
                                                  _createElementVNode("td", _hoisted_66, [
                                                    _withDirectives(_createElementVNode("select", {
                                                      class: _normalizeClass(["widthForSelect", _ctx.filterDummy.overallImpact == '' ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.filterDummy.overallImpact) = $event))
                                                    }, [
                                                      _cache[97] || (_cache[97] = _createElementVNode("option", {
                                                        value: "",
                                                        selected: "",
                                                        disabled: "",
                                                        hidden: ""
                                                      }, "Select", -1)),
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbOverAllImpact, (pair) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                          class: "optionColors",
                                                          key: pair,
                                                          value: pair.value
                                                        }, _toDisplayString(pair.key), 9, _hoisted_67))
                                                      }), 128))
                                                    ], 2), [
                                                      [_vModelSelect, _ctx.filterDummy.overallImpact]
                                                    ])
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          (_ctx.sortedData.length == 0)
                                            ? (_openBlock(), _createElementBlock("tbody", _hoisted_68, _cache[99] || (_cache[99] = [
                                                _createElementVNode("tr", { class: "cursor-pointer rowHeight" }, [
                                                  _createElementVNode("td", { colspan: 6 }, [
                                                    _createElementVNode("div", { class: "flex justify-center" }, [
                                                      _createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
                                                    ])
                                                  ])
                                                ], -1)
                                              ])))
                                            : (_openBlock(), _createElementBlock("tbody", _hoisted_69, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedData, (riskItem, index) => {
                                                  return (_openBlock(), _createElementBlock("tr", {
                                                    class: "rowHeight",
                                                    key: index,
                                                    onClick: ($event: any) => (_ctx.openRisk(riskItem))
                                                  }, [
                                                    _createElementVNode("td", {
                                                      onMouseout: _cache[17] || (_cache[17] = ($event: any) => (_ctx.doFalse()))
                                                    }, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        class: "checkbox",
                                                        type: "checkbox",
                                                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.checkedItems) = $event)),
                                                        value: riskItem._id,
                                                        onChange: ($event: any) => (_ctx.changeInfo(riskItem, $event))
                                                      }, null, 40, _hoisted_71), [
                                                        [_vModelCheckbox, _ctx.checkedItems]
                                                      ])
                                                    ], 32),
                                                    _createElementVNode("td", {
                                                      class: "relative cursor-pointer",
                                                      onMouseout: _cache[18] || (_cache[18] = ($event: any) => (_ctx.doFalse()))
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(["flex items-center justify-center rounded-full ml-3 w-5 h-5", _ctx.colorPropBg('border', riskItem.severity)]),
                                                        onMousemove: ($event: any) => (_ctx.toolTip(riskItem, 'severity', riskItem.severity, index, $event))
                                                      }, [
                                                        _createElementVNode("div", {
                                                          class: _normalizeClass(["severityCircle rounded-full", _ctx.colorPropBg('circle', riskItem.severity)])
                                                        }, null, 2)
                                                      ], 42, _hoisted_72)
                                                    ], 32),
                                                    _createElementVNode("td", {
                                                      class: "relative",
                                                      onMouseout: _cache[19] || (_cache[19] = ($event: any) => (_ctx.doFalse()))
                                                    }, [
                                                      _createElementVNode("div", _hoisted_73, [
                                                        _createElementVNode("p", {
                                                          class: "cursor-pointer text-xs",
                                                          onMousemove: ($event: any) => (_ctx.toolTip(riskItem, 'risk', riskItem.risk, index, $event))
                                                        }, _toDisplayString(riskItem.risk), 41, _hoisted_74)
                                                      ])
                                                    ], 32),
                                                    _createElementVNode("td", {
                                                      class: "relative",
                                                      onMouseout: _cache[20] || (_cache[20] = ($event: any) => (_ctx.doFalse()))
                                                    }, [
                                                      _createElementVNode("div", _hoisted_75, [
                                                        _createElementVNode("p", {
                                                          class: "cursor-pointer text-xs",
                                                          onMousemove: ($event: any) => (_ctx.toolTip(riskItem, 'riskCategory', riskItem.riskCategory, index, $event))
                                                        }, _toDisplayString(riskItem.riskCategory), 41, _hoisted_76)
                                                      ])
                                                    ], 32),
                                                    _createElementVNode("td", null, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(["flex items-center justify-center relative rounded regular text-xs w-24 h-5", _ctx.colorRiskText(riskItem.likelihood)])
                                                      }, [
                                                        (!isNaN(riskItem.likelihood))
                                                          ? (_openBlock(), _createElementBlock("div", {
                                                              key: 0,
                                                              class: _normalizeClass(["w-full h-full absolute rounded flex items-center justify-center", _ctx.colorRiskBg(riskItem.likelihood)])
                                                            }, _toDisplayString(_ctx.getRiskStateValue(riskItem.likelihood)), 3))
                                                          : _createCommentVNode("", true)
                                                      ], 2)
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(["flex items-center justify-center relative rounded regular text-xs w-24 h-5", _ctx.colorRiskText(riskItem.overallImpact)])
                                                      }, [
                                                        (!isNaN(riskItem.overallImpact))
                                                          ? (_openBlock(), _createElementBlock("div", {
                                                              key: 0,
                                                              class: _normalizeClass(["w-full h-full absolute rounded flex items-center justify-center", _ctx.colorRiskBg(riskItem.overallImpact)])
                                                            }, _toDisplayString(_ctx.getOverallState(riskItem.overallImpact)), 3))
                                                          : _createCommentVNode("", true)
                                                      ], 2)
                                                    ])
                                                  ], 8, _hoisted_70))
                                                }), 128))
                                              ]))
                                        ])
                                      ]),
                                      (_ctx.sortedData.length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                            _createVNode(_component_pagination, {
                                              dynamicPagination: _ctx.dynamicPagination,
                                              onCurrentPageUpdate: _ctx.paginationUpdations,
                                              sortedData: _ctx.sortedData
                                            }, null, 8, ["dynamicPagination", "onCurrentPageUpdate", "sortedData"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.toolTipActive)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                                      _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    (_ctx.openRiskPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 0,
          popUp: _ctx.openRiskPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_79, [
              _cache[101] || (_cache[101] = _createElementVNode("h1", null, "Risk Information", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.onCancelButton('close')))
              }, _cache[100] || (_cache[100] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_80, [
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("div", _hoisted_82, [
                  _createElementVNode("div", _hoisted_83, [
                    _createElementVNode("div", _hoisted_84, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_85, [
                          _cache[103] || (_cache[103] = _createElementVNode("label", { class: "controllabel" }, "Risk", -1)),
                          (_ctx.orgRisksTab.statusCode==10401 ||_ctx.addingRisk==true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                _withDirectives(_createElementVNode("textarea", {
                                  type: "text",
                                  class: _normalizeClass(["inputboxstyling", { 'is-invalid': (_ctx.v$.orgRisksTab.risk.$error||_ctx.displayErrorMessageOfRisk) }]),
                                  onInput: _cache[23] || (_cache[23] = ($event: any) => (_ctx.restrictCharacters('Risk'))),
                                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.orgRisksTab.risk) = $event)),
                                  placeholder: "Risk"
                                }, null, 34), [
                                  [
                                    _vModelText,
                                    _ctx.orgRisksTab.risk,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (_ctx.v$.orgRisksTab.risk.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                                      (_ctx.v$.orgRisksTab.risk.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_88, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : (_ctx.displayErrorMessageOfRisk == true)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_89, _cache[102] || (_cache[102] = [
                                        _createElementVNode("div", { class: "text-red-500 text-xs" }, "Character Limit is exceeded", -1)
                                      ])))
                                    : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_90, _toDisplayString(_ctx.orgRisksTab.risk||'N/A'), 1))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_91, [
                      _createElementVNode("div", _hoisted_92, [
                        _createElementVNode("div", _hoisted_93, [
                          _cache[105] || (_cache[105] = _createElementVNode("label", { class: "controllabel" }, "Risk Category", -1)),
                          (_ctx.orgRisksTab.statusCode==10401||_ctx.addingRisk==true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.orgRisksTab.riskCategory,
                                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.orgRisksTab.riskCategory) = $event)),
                                  options: _ctx.riskCategoryList,
                                  placeholder: "Risk Category",
                                  class: _normalizeClass(["custom-multiselect w-full", {
                                            'is-invalid': _ctx.v$.orgRisksTab.riskCategory.$error,
                                            'has-options': _ctx.riskCategoryList && _ctx.riskCategoryList.length > 0,
                                            'no-options':  !_ctx.riskCategoryList.length,
                                        }])
                                }, {
                                  empty: _withCtx(() => _cache[104] || (_cache[104] = [
                                    _createElementVNode("span", { class: "text-xs" }, "No Categories Found", -1)
                                  ])),
                                  _: 1
                                }, 8, ["modelValue", "options", "class"]),
                                (_ctx.v$.orgRisksTab.riskCategory.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                                      (_ctx.v$.orgRisksTab.riskCategory.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_96, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_97, _toDisplayString(_ctx.orgRisksTab.riskCategory||'N/A'), 1))
                        ]),
                        _createElementVNode("div", _hoisted_98, [
                          _cache[107] || (_cache[107] = _createElementVNode("label", { class: "controllabel" }, "Risk Owner", -1)),
                          (_ctx.orgRisksTab.statusCode==10401||_ctx.addingRisk==true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                                _createVNode(_component_AutoComplete, {
                                  modelValue: _ctx.orgRisksTab.riskOwner,
                                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.orgRisksTab.riskOwner) = $event)),
                                  suggestions: _ctx.userOptions,
                                  onComplete: _ctx.asyncFind,
                                  optionLabel: "label",
                                  optionValue: "value",
                                  forceSelection: "",
                                  placeholder: "Risk Owner",
                                  class: _normalizeClass(["custom-multiselect w-full", {
                                                'p-invalid':  _ctx.v$.orgRisksTab.riskOwner.$error,
                                                'has-options': _ctx.userOptions && _ctx.userOptions.length > 0,
                                                'no-options': !_ctx.userOptions.length &&  _ctx.searchValue !== '',
                                            }])
                                }, {
                                  empty: _withCtx(() => _cache[106] || (_cache[106] = [
                                    _createElementVNode("span", { class: "text-xs" }, "No Members Found", -1)
                                  ])),
                                  _: 1
                                }, 8, ["modelValue", "suggestions", "onComplete", "class"]),
                                (_ctx.v$.orgRisksTab.riskOwner.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                                      (_ctx.v$.orgRisksTab.riskOwner.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_101, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_102, _toDisplayString(_ctx.orgRisksTab.riskOwner?.label||'N/A'), 1))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_103, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_104, [
                          _cache[109] || (_cache[109] = _createElementVNode("label", { class: "controllabel" }, "Threat", -1)),
                          (_ctx.orgRisksTab.statusCode==10401||_ctx.addingRisk==true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                                _withDirectives(_createElementVNode("textarea", {
                                  type: "text",
                                  class: _normalizeClass(["inputboxstyling", { 'is-invalid': (_ctx.v$.orgRisksTab.threatEvent.$error||_ctx.displayErrorMessageOfThreat) }]),
                                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.orgRisksTab.threatEvent) = $event)),
                                  onInput: _cache[28] || (_cache[28] = ($event: any) => (_ctx.restrictCharacters('Threat'))),
                                  placeholder: "Threat"
                                }, null, 34), [
                                  [
                                    _vModelText,
                                    _ctx.orgRisksTab.threatEvent,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (_ctx.v$.orgRisksTab.threatEvent.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                                      (_ctx.v$.orgRisksTab.threatEvent.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_107, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : (_ctx.displayErrorMessageOfThreat == true)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_108, _cache[108] || (_cache[108] = [
                                        _createElementVNode("div", { class: "text-red-500 text-xs" }, "Character Limit is exceeded", -1)
                                      ])))
                                    : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_109, _toDisplayString(_ctx.orgRisksTab.threatEvent||'N/A'), 1))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_110, [
                      _createElementVNode("div", _hoisted_111, [
                        _createElementVNode("div", _hoisted_112, [
                          _cache[111] || (_cache[111] = _createElementVNode("label", { class: "controllabel" }, "Threat Source", -1)),
                          (_ctx.orgRisksTab.statusCode==10401||_ctx.addingRisk==true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.orgRisksTab.threatSource,
                                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.orgRisksTab.threatSource) = $event)),
                                  options: _ctx.threatSourceList,
                                  placeholder: "Threat Source",
                                  class: _normalizeClass(["custom-multiselect w-full", {
                                            'is-invalid': _ctx.v$.orgRisksTab.threatSource.$error,
                                            'has-options': _ctx.threatSourceList && _ctx.threatSourceList.length > 0,
                                            'no-options':  !_ctx.threatSourceList.length,
                                        }])
                                }, {
                                  empty: _withCtx(() => _cache[110] || (_cache[110] = [
                                    _createElementVNode("span", { class: "text-xs" }, "No Categories Found", -1)
                                  ])),
                                  _: 1
                                }, 8, ["modelValue", "options", "class"]),
                                (_ctx.v$.orgRisksTab.threatSource.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                                      (_ctx.v$.orgRisksTab.threatSource.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_115, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_116, _toDisplayString(_ctx.orgRisksTab.threatSource||'N/A'), 1))
                        ]),
                        _createElementVNode("div", _hoisted_117, [
                          _cache[113] || (_cache[113] = _createElementVNode("label", { class: "controllabel" }, "Threat Category", -1)),
                          (_ctx.orgRisksTab.statusCode==10401||_ctx.addingRisk==true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.orgRisksTab.threatCategory,
                                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.orgRisksTab.threatCategory) = $event)),
                                  options: _ctx.threatCategoryList,
                                  placeholder: "Threat Category",
                                  class: _normalizeClass(["custom-multiselect w-full", {
                                            'is-invalid': _ctx.v$.orgRisksTab.threatCategory.$error,
                                            'has-options': _ctx.threatCategoryList && _ctx.threatCategoryList.length > 0,
                                            'no-options':  !_ctx.threatCategoryList.length,
                                        }])
                                }, {
                                  empty: _withCtx(() => _cache[112] || (_cache[112] = [
                                    _createElementVNode("span", { class: "text-xs" }, "No Categories Found", -1)
                                  ])),
                                  _: 1
                                }, 8, ["modelValue", "options", "class"]),
                                (_ctx.v$.orgRisksTab.threatCategory.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                                      (_ctx.v$.orgRisksTab.threatCategory.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_120, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_121, _toDisplayString(_ctx.orgRisksTab.risk||'N/A'), 1))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_122, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_123, [
                          _cache[115] || (_cache[115] = _createElementVNode("label", { class: "controllabel" }, "Vulnerability", -1)),
                          (_ctx.orgRisksTab.statusCode==10401||_ctx.addingRisk==true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                                _withDirectives(_createElementVNode("textarea", {
                                  type: "text",
                                  class: _normalizeClass(["inputboxstyling", { 'is-invalid': _ctx.v$.orgRisksTab.vulnerability.$error||_ctx.displayErrorMessageOfVulnerability }]),
                                  onInput: _cache[31] || (_cache[31] = ($event: any) => (_ctx.restrictCharacters('Vulnerability'))),
                                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.orgRisksTab.vulnerability) = $event)),
                                  placeholder: "Vulnerability"
                                }, null, 34), [
                                  [
                                    _vModelText,
                                    _ctx.orgRisksTab.vulnerability,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (_ctx.v$.orgRisksTab.vulnerability.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                                      (_ctx.v$.orgRisksTab.vulnerability.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_126, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : (_ctx.displayErrorMessageOfVulnerability == true)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_127, _cache[114] || (_cache[114] = [
                                        _createElementVNode("div", { class: "text-red-500 text-xs" }, "Character Limit is exceeded", -1)
                                      ])))
                                    : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_128, _toDisplayString(_ctx.orgRisksTab.vulnerability||'N/A'), 1))
                        ])
                      ])
                    ]),
                    _cache[122] || (_cache[122] = _createElementVNode("h1", { class: "upperspacing" }, "Impact Analysis", -1)),
                    _cache[123] || (_cache[123] = _createElementVNode("div", { class: "border-b mt-1 border-solid border-lightgrey" }, null, -1)),
                    _createElementVNode("div", _hoisted_129, [
                      _createElementVNode("div", _hoisted_130, [
                        _createElementVNode("div", _hoisted_131, [
                          _cache[116] || (_cache[116] = _createElementVNode("label", { class: "controllabel" }, "Strategic", -1)),
                          (_ctx.orgRisksTab.statusCode==10401||_ctx.addingRisk==true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.orgRisksTab.business,
                                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.orgRisksTab.business) = $event)),
                                  options: _ctx.dbBussiness,
                                  optionLabel: "key",
                                  optionValue: "value",
                                  placeholder: "Please select one",
                                  onChange: _cache[34] || (_cache[34] = ($event: any) => (_ctx.calculateOverallImpact())),
                                  class: _normalizeClass(["custom-multiselect w-full", {
                                                'is-invalid': _ctx.v$.orgRisksTab.business.$error,
                                                'inputboxstylingForSelectAtPopup': _ctx.orgRisksTab.business === '',
                                                'stylingForInputboxstylingForSelectAtPopup': _ctx.orgRisksTab.business !== '' 

                                            }])
                                }, null, 8, ["modelValue", "options", "class"]),
                                (_ctx.v$.orgRisksTab.business.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                                      (_ctx.v$.orgRisksTab.business.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_134, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_135, _toDisplayString(_ctx.lablesData(_ctx.orgRisksTab.business,1)||'N/A'), 1))
                        ]),
                        _createElementVNode("div", _hoisted_136, [
                          _cache[117] || (_cache[117] = _createElementVNode("label", { class: "controllabel" }, "Financial", -1)),
                          (_ctx.orgRisksTab.statusCode==10401||_ctx.addingRisk==true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.orgRisksTab.financial,
                                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.orgRisksTab.financial) = $event)),
                                  options: _ctx.dbFinancial,
                                  optionLabel: "key",
                                  optionValue: "value",
                                  placeholder: "Please select one",
                                  onChange: _cache[36] || (_cache[36] = ($event: any) => (_ctx.calculateOverallImpact())),
                                  class: _normalizeClass(["custom-multiselect w-full", {
                                                'is-invalid': _ctx.v$.orgRisksTab.financial.$error,
                                                'inputboxstylingForSelectAtPopup': _ctx.orgRisksTab.financial === '',
                                                'stylingForInputboxstylingForSelectAtPopup': _ctx.orgRisksTab.financial !== '' 

                                            }])
                                }, null, 8, ["modelValue", "options", "class"]),
                                (_ctx.v$.orgRisksTab.financial.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                                      (_ctx.v$.orgRisksTab.financial.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_139, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_140, _toDisplayString(_ctx.lablesData(_ctx.orgRisksTab.financial,2)||'N/A'), 1))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_141, [
                      _createElementVNode("div", _hoisted_142, [
                        _createElementVNode("div", _hoisted_143, [
                          _cache[118] || (_cache[118] = _createElementVNode("label", { class: "controllabel" }, "Operations", -1)),
                          (_ctx.orgRisksTab.statusCode==10401||_ctx.addingRisk==true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_144, [
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.orgRisksTab.operations,
                                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.orgRisksTab.operations) = $event)),
                                  options: _ctx.dbOperations,
                                  optionLabel: "key",
                                  optionValue: "value",
                                  placeholder: "Please select one",
                                  onChange: _cache[38] || (_cache[38] = ($event: any) => (_ctx.calculateOverallImpact())),
                                  class: _normalizeClass(["custom-multiselect w-full", {
                                                'is-invalid': _ctx.v$.orgRisksTab.operations.$error,
                                                'inputboxstylingForSelectAtPopup': _ctx.orgRisksTab.operations === '',
                                                'stylingForInputboxstylingForSelectAtPopup': _ctx.orgRisksTab.operations !== ''  

                                            }])
                                }, null, 8, ["modelValue", "options", "class"]),
                                (_ctx.v$.orgRisksTab.operations.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_145, [
                                      (_ctx.v$.orgRisksTab.operations.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_146, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_147, _toDisplayString(_ctx.lablesData(_ctx.orgRisksTab.operations,3)||'N/A'), 1))
                        ]),
                        _createElementVNode("div", _hoisted_148, [
                          _cache[119] || (_cache[119] = _createElementVNode("label", { class: "controllabel" }, "Compliance", -1)),
                          (_ctx.orgRisksTab.statusCode==10401||_ctx.addingRisk==true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_149, [
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.orgRisksTab.legal,
                                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.orgRisksTab.legal) = $event)),
                                  options: _ctx.dbLegal,
                                  optionLabel: "key",
                                  optionValue: "value",
                                  placeholder: "Please select one",
                                  onChange: _cache[40] || (_cache[40] = ($event: any) => (_ctx.calculateOverallImpact())),
                                  class: _normalizeClass(["custom-multiselect w-full", {
                                                'is-invalid': _ctx.v$.orgRisksTab.legal.$error,
                                                'inputboxstylingForSelectAtPopup': _ctx.orgRisksTab.legal === '',
                                                'stylingForInputboxstylingForSelectAtPopup': _ctx.orgRisksTab.legal !== ''
                                            }])
                                }, null, 8, ["modelValue", "options", "class"]),
                                (_ctx.v$.orgRisksTab.legal.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_150, [
                                      (_ctx.v$.orgRisksTab.legal.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_151, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_152, _toDisplayString(_ctx.lablesData(_ctx.orgRisksTab.legal,4)||'N/A'), 1))
                        ])
                      ])
                    ]),
                    _cache[124] || (_cache[124] = _createElementVNode("h1", { class: "upperspacing" }, "Risk Analysis", -1)),
                    _cache[125] || (_cache[125] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                    _createElementVNode("div", _hoisted_153, [
                      _createElementVNode("div", _hoisted_154, [
                        _createElementVNode("div", _hoisted_155, [
                          _cache[120] || (_cache[120] = _createElementVNode("label", { class: "controllabel" }, "Likelihood", -1)),
                          (_ctx.orgRisksTab.statusCode==10401||_ctx.addingRisk==true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_156, [
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.orgRisksTab.likelihood,
                                  "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.orgRisksTab.likelihood) = $event)),
                                  options: _ctx.dbLegal,
                                  optionLabel: "key",
                                  optionValue: "value",
                                  placeholder: "Please select one",
                                  class: _normalizeClass(["custom-multiselect w-full", {
                                                'is-invalid':_ctx.v$.orgRisksTab.likelihood.$error,
                                                'inputboxstylingForSelectAtPopup': _ctx.orgRisksTab.likelihood === '',
                                                'stylingForInputboxstylingForSelectAtPopup': _ctx.orgRisksTab.likelihood !== '' 
                                            }])
                                }, null, 8, ["modelValue", "options", "class"]),
                                (_ctx.v$.orgRisksTab.likelihood.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_157, [
                                      (_ctx.v$.orgRisksTab.likelihood.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_158, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_159, _toDisplayString(_ctx.lablesData(_ctx.orgRisksTab.likelihood,5)||'N/A'), 1))
                        ]),
                        _createElementVNode("div", _hoisted_160, [
                          _cache[121] || (_cache[121] = _createElementVNode("label", { class: "controllabel" }, "Overall Impact", -1)),
                          (_ctx.orgRisksTab.statusCode==10401||_ctx.addingRisk==true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_161, [
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.orgRisksTab.overallImpact,
                                  "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.orgRisksTab.overallImpact) = $event)),
                                  options: _ctx.dbOverAllImpact,
                                  disabled: "",
                                  optionLabel: "key",
                                  optionValue: "value",
                                  placeholder: "Please select one",
                                  class: "custom-multiselect w-full"
                                }, null, 8, ["modelValue", "options"])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_162, _toDisplayString(_ctx.lablesData(_ctx.orgRisksTab.overallImpact,6)||'N/A'), 1))
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              (_ctx.orgRisksTab.statusCode==10401||_ctx.addingRisk==true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_163, [
                    _cache[126] || (_cache[126] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                    _createElementVNode("div", _hoisted_164, [
                      _createElementVNode("button", {
                        disabled: _ctx.clickOnButton,
                        class: _normalizeClass(["btnprimary mr-2 gap-2", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                        onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.onCancelButton('cancel')))
                      }, "Reset", 10, _hoisted_165),
                      (_ctx.addingRisk)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            disabled: _ctx.clickOnButton,
                            class: _normalizeClass(["btnprimary mr-1.5", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                            onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.addOrUpdaterisk(_ctx.orgRisksTab)))
                          }, "Save", 10, _hoisted_166))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            disabled: _ctx.clickOnButton,
                            class: _normalizeClass(["btnprimary mr-1.5", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                            onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.addOrUpdaterisk(_ctx.orgRisksTab)))
                          }, "Update", 10, _hoisted_167))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.openRiskInformation)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 1,
          popUp: _ctx.openRiskInformation
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_168, [
              _cache[128] || (_cache[128] = _createElementVNode("h1", null, "Risk Information", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.onCancelButton('close')))
              }, _cache[127] || (_cache[127] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_169, [
              _createElementVNode("div", _hoisted_170, [
                _createElementVNode("div", _hoisted_171, [
                  _createElementVNode("div", _hoisted_172, [
                    _createElementVNode("div", _hoisted_173, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_174, [
                          _cache[129] || (_cache[129] = _createElementVNode("label", { class: "controllabel" }, "Risk", -1)),
                          _createElementVNode("div", _hoisted_175, _toDisplayString(_ctx.orgRisksTab.risk  != undefined ? _ctx.orgRisksTab.risk : 'N/A'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_176, [
                      _createElementVNode("div", _hoisted_177, [
                        _createElementVNode("div", _hoisted_178, [
                          _cache[130] || (_cache[130] = _createElementVNode("label", { class: "controllabel" }, "Risk Category", -1)),
                          _createElementVNode("div", _hoisted_179, _toDisplayString(_ctx.orgRisksTab.riskCategory  != undefined ? _ctx.orgRisksTab.riskCategory : 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_180, [
                          _cache[131] || (_cache[131] = _createElementVNode("label", { class: "controllabel" }, "Risk Owner", -1)),
                          _createElementVNode("div", _hoisted_181, _toDisplayString(_ctx.orgRisksTab.riskOwner  != undefined ? _ctx.orgRisksTab.riskOwner : 'N/A'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_182, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_183, [
                          _cache[132] || (_cache[132] = _createElementVNode("label", { class: "controllabel" }, "Threat", -1)),
                          _createElementVNode("div", _hoisted_184, _toDisplayString(_ctx.orgRisksTab.threatEvent  != undefined ? _ctx.orgRisksTab.threatEvent : 'N/A'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_185, [
                      _createElementVNode("div", _hoisted_186, [
                        _createElementVNode("div", _hoisted_187, [
                          _cache[133] || (_cache[133] = _createElementVNode("label", { class: "controllabel" }, "Threat Source", -1)),
                          _createElementVNode("div", _hoisted_188, _toDisplayString(_ctx.orgRisksTab.threatSource  != undefined ? _ctx.orgRisksTab.threatSource : 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_189, [
                          _cache[134] || (_cache[134] = _createElementVNode("label", { class: "controllabel" }, "Threat Category", -1)),
                          _createElementVNode("div", _hoisted_190, _toDisplayString(_ctx.orgRisksTab.threatCategory  != undefined ? _ctx.orgRisksTab.threatCategory : 'N/A'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_191, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_192, [
                          _cache[135] || (_cache[135] = _createElementVNode("label", { class: "controllabel" }, "Vulnerability", -1)),
                          _createElementVNode("div", _hoisted_193, _toDisplayString(_ctx.orgRisksTab.vulnerability  != undefined ? _ctx.orgRisksTab.vulnerability : 'N/A'), 1)
                        ])
                      ])
                    ]),
                    _cache[142] || (_cache[142] = _createElementVNode("h1", { class: "upperspacing" }, "Impact Analysis", -1)),
                    _cache[143] || (_cache[143] = _createElementVNode("div", { class: "border-b mt-1 border-solid border-lightgrey" }, null, -1)),
                    _createElementVNode("div", _hoisted_194, [
                      _createElementVNode("div", _hoisted_195, [
                        _createElementVNode("div", _hoisted_196, [
                          _cache[136] || (_cache[136] = _createElementVNode("label", { class: "controllabel" }, "Strategic", -1)),
                          _createElementVNode("div", _hoisted_197, _toDisplayString(_ctx.orgRisksTab.business  != undefined ? _ctx.dbOperations.find(a=>a.value==_ctx.orgRisksTab.business)?.key : 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_198, [
                          _cache[137] || (_cache[137] = _createElementVNode("label", { class: "controllabel" }, "Financial", -1)),
                          _createElementVNode("div", _hoisted_199, _toDisplayString(_ctx.orgRisksTab.financial  != undefined ?  _ctx.dbFinancial.find(a=>a.value==_ctx.orgRisksTab.business)?.key  : 'N/A'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_200, [
                      _createElementVNode("div", _hoisted_201, [
                        _createElementVNode("div", _hoisted_202, [
                          _cache[138] || (_cache[138] = _createElementVNode("label", { class: "controllabel" }, "Operations", -1)),
                          _createElementVNode("div", _hoisted_203, _toDisplayString(_ctx.orgRisksTab.operations  != undefined ? _ctx.dbOperations.find(a=>a.value==_ctx.orgRisksTab.business)?.key : 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_204, [
                          _cache[139] || (_cache[139] = _createElementVNode("label", { class: "controllabel" }, "Compliance", -1)),
                          _createElementVNode("div", _hoisted_205, _toDisplayString(_ctx.orgRisksTab.legal  != undefined ? _ctx.dbLegal.find(a=>a.value==_ctx.orgRisksTab.business)?.key : 'N/A'), 1)
                        ])
                      ])
                    ]),
                    _cache[144] || (_cache[144] = _createElementVNode("h1", { class: "upperspacing" }, "Risk Analysis", -1)),
                    _cache[145] || (_cache[145] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                    _createElementVNode("div", _hoisted_206, [
                      _createElementVNode("div", _hoisted_207, [
                        _createElementVNode("div", _hoisted_208, [
                          _cache[140] || (_cache[140] = _createElementVNode("label", { class: "controllabel" }, "Likelihood", -1)),
                          _createElementVNode("div", _hoisted_209, _toDisplayString(_ctx.orgRisksTab.likelihood  != undefined ? _ctx.dbLikelihood.find(a=>a.value==_ctx.orgRisksTab.business)?.key : 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_210, [
                          _cache[141] || (_cache[141] = _createElementVNode("label", { class: "controllabel" }, "Overall Impact", -1)),
                          _createElementVNode("div", _hoisted_211, _toDisplayString(_ctx.orgRisksTab.overallImpact  != undefined ? _ctx.dbOverAllImpact.find(a=>a.value==_ctx.orgRisksTab.overallImpact)?.key : 'N/A'), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _cache[146] || (_cache[146] = _createElementVNode("div", null, null, -1))
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.showInfoPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 2,
          popUp: _ctx.showInfoPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_212, [
              _cache[148] || (_cache[148] = _createElementVNode("h1", null, "Information", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.onCloseInformation()))
              }, _cache[147] || (_cache[147] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_213, [
              _createElementVNode("div", _hoisted_214, [
                _createElementVNode("div", _hoisted_215, [
                  _createElementVNode("div", _hoisted_216, [
                    _createElementVNode("div", _hoisted_217, [
                      (_ctx.information.information != '' && !_ctx.addInfo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_218, [
                            _cache[149] || (_cache[149] = _createElementVNode("label", { class: "controllabel" }, "Information Category", -1)),
                            _createElementVNode("div", _hoisted_219, _toDisplayString(_ctx.information.informationCategory), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_220, [
                            _cache[151] || (_cache[151] = _createElementVNode("label", { class: "controllabel" }, "Information Category", -1)),
                            _createVNode(_component_Select, {
                              modelValue: _ctx.information.informationCategory,
                              "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.information.informationCategory) = $event)),
                              options: _ctx.infoCategoryList,
                              onSelect: _cache[49] || (_cache[49] = ($event: any) => (_ctx.changeInfoCategory(_ctx.information.informationCategory))),
                              placeholder: "Information Category",
                              class: _normalizeClass(["custom-multiselect w-full", {
                                                'is-invalid': _ctx.v$.information.informationCategory.$error,
                                                'has-options': _ctx.infoCategoryList && _ctx.infoCategoryList.length > 0,
                                                'no-options':  !_ctx.infoCategoryList.length,
                                            }])
                            }, {
                              empty: _withCtx(() => _cache[150] || (_cache[150] = [
                                _createElementVNode("span", { class: "text-xs" }, "No Categories Found", -1)
                              ])),
                              _: 1
                            }, 8, ["modelValue", "options", "class"]),
                            (_ctx.v$.information.informationCategory.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_221, [
                                  (_ctx.v$.information.informationCategory.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_222, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_223, [
                      (_ctx.information.information != '' && !_ctx.addInfo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_224, [
                            _cache[152] || (_cache[152] = _createElementVNode("label", { class: "controllabel" }, "Information", -1)),
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_225, _toDisplayString(_ctx.information.information), 1)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_226, [
                            _cache[154] || (_cache[154] = _createElementVNode("label", { class: "controllabel" }, "Information", -1)),
                            _createVNode(_component_Select, {
                              modelValue: _ctx.information.information,
                              "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.information.information) = $event)),
                              options: _ctx.infoList,
                              disabled: !_ctx.addInfo || _ctx.information.informationCategory == '',
                              onChange: _cache[51] || (_cache[51] = ($event: any) => (_ctx.changeInformation(_ctx.information.information))),
                              placeholder: "Information Category",
                              class: _normalizeClass(["custom-multiselect w-full", {
                                                'is-invalid': _ctx.v$.information.information.$error,
                                                'has-options': _ctx.infoList && _ctx.infoList.length > 0,
                                                'no-options':  !_ctx.infoList.length,
                                            }])
                            }, {
                              empty: _withCtx(() => _cache[153] || (_cache[153] = [
                                _createElementVNode("span", { class: "text-xs" }, "No Categories Found", -1)
                              ])),
                              _: 1
                            }, 8, ["modelValue", "options", "disabled", "class"]),
                            (_ctx.v$.information.information.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_227, [
                                  (_ctx.v$.information.information.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_228, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_229, [
                      (_ctx.information.information != '' && !_ctx.addInfo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_230, [
                            _cache[155] || (_cache[155] = _createElementVNode("label", { class: "controllabel" }, "Information Owner", -1)),
                            _createElementVNode("div", _hoisted_231, _toDisplayString(_ctx.information.informationOwner.label), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_232, [
                            _cache[157] || (_cache[157] = _createElementVNode("label", { class: "controllabel" }, "Information Owner", -1)),
                            _createVNode(_component_Select, {
                              modelValue: _ctx.information.informationOwner,
                              "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.information.informationOwner) = $event)),
                              options: _ctx.optionsUserArray,
                              optionLabel: "label",
                              optionValue: "value",
                              disabled: "",
                              placeholder: "Information Owner",
                              class: "custom-multiselect w-full"
                            }, {
                              empty: _withCtx(() => _cache[156] || (_cache[156] = [
                                _createElementVNode("span", { class: "text-xs" }, "No Categories Found", -1)
                              ])),
                              _: 1
                            }, 8, ["modelValue", "options"])
                          ])),
                      (_ctx.information.confidentiality != '' || !_ctx.addInfo || !_ctx.addCIAInfo)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: _normalizeClass(["w-6/12", !_ctx.information._id ? 'leftspacing': ''])
                          }, [
                            _cache[158] || (_cache[158] = _createElementVNode("label", { class: "controllabel" }, "Confidentiality", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbConfidentiality, (dataValue, indexNum) => {
                              return (_openBlock(), _createElementBlock("div", { key: indexNum }, [
                                (_ctx.information.confidentiality == dataValue.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_233, [
                                      _createElementVNode("div", _hoisted_234, _toDisplayString(dataValue.key), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ], 2))
                        : (_openBlock(), _createElementBlock("div", _hoisted_235, [
                            _cache[159] || (_cache[159] = _createElementVNode("label", { class: "controllabel" }, "Confidentiality", -1)),
                            _createVNode(_component_Select, {
                              modelValue: _ctx.information.confidentiality,
                              "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.information.confidentiality) = $event)),
                              options: _ctx.dbConfidentiality,
                              disabled: "",
                              optionLabel: "key",
                              optionValue: "value",
                              placeholder: "Please select one",
                              onChange: _cache[54] || (_cache[54] = ($event: any) => (_ctx.getMaxIdValue())),
                              class: "custom-multiselect w-full"
                            }, null, 8, ["modelValue", "options"])
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_236, [
                      (_ctx.information.integrity != '' || !_ctx.addInfo || !_ctx.addCIAInfo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_237, [
                            _cache[160] || (_cache[160] = _createElementVNode("label", { class: "controllabel" }, "Integrity", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbIntegrity, (dataValue, indexNum) => {
                              return (_openBlock(), _createElementBlock("div", { key: indexNum }, [
                                (_ctx.information.integrity == dataValue.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_238, [
                                      _createElementVNode("div", _hoisted_239, _toDisplayString(dataValue.key), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_240, [
                            _cache[161] || (_cache[161] = _createElementVNode("label", { class: "controllabel" }, "Integrity", -1)),
                            _createVNode(_component_Select, {
                              modelValue: _ctx.information.integrity,
                              "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.information.integrity) = $event)),
                              options: _ctx.dbIntegrity,
                              disabled: "",
                              optionLabel: "key",
                              optionValue: "value",
                              placeholder: "Please select one",
                              onChange: _cache[56] || (_cache[56] = ($event: any) => (_ctx.getMaxIdValue())),
                              class: "custom-multiselect w-full"
                            }, null, 8, ["modelValue", "options"])
                          ])),
                      (_ctx.information.availability != '' || !_ctx.addInfo || !_ctx.addCIAInfo)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: _normalizeClass(["w-6/12", _ctx.information._id ? '' : 'leftspacing'])
                          }, [
                            _cache[162] || (_cache[162] = _createElementVNode("label", { class: "controllabel" }, "Availability", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbAvailability, (dataValue, indexNum) => {
                              return (_openBlock(), _createElementBlock("div", { key: indexNum }, [
                                (_ctx.information.availability == dataValue.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_241, [
                                      _createElementVNode("div", _hoisted_242, _toDisplayString(dataValue.key), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ], 2))
                        : (_openBlock(), _createElementBlock("div", _hoisted_243, [
                            _cache[163] || (_cache[163] = _createElementVNode("label", { class: "controllabel" }, "Availability", -1)),
                            _createVNode(_component_Select, {
                              modelValue: _ctx.information.availability,
                              "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.information.availability) = $event)),
                              options: _ctx.dbAvailability,
                              disabled: "",
                              optionLabel: "key",
                              optionValue: "value",
                              placeholder: "Please select one",
                              onChange: _cache[58] || (_cache[58] = ($event: any) => (_ctx.getMaxIdValue())),
                              class: "custom-multiselect w-full"
                            }, null, 8, ["modelValue", "options"])
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_244, [
                      (_ctx.information.classification != '' || !_ctx.addInfo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_245, [
                            _cache[164] || (_cache[164] = _createElementVNode("label", { class: "controllabel" }, "Classification", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbInformationClassification, (dataValue, indexNum) => {
                              return (_openBlock(), _createElementBlock("div", { key: indexNum }, [
                                (_ctx.information.classification == dataValue.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_246, [
                                      _createElementVNode("div", _hoisted_247, _toDisplayString(dataValue.key), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_248, [
                            _cache[165] || (_cache[165] = _createElementVNode("label", { class: "controllabel" }, "Classification", -1)),
                            _createVNode(_component_Select, {
                              modelValue: _ctx.information.classification,
                              "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.information.classification) = $event)),
                              options: _ctx.dbInformationClassification,
                              disabled: "",
                              optionLabel: "key",
                              optionValue: "value",
                              placeholder: "Please select one",
                              onChange: _cache[60] || (_cache[60] = ($event: any) => (_ctx.getMaxIdValue())),
                              class: _normalizeClass(["custom-multiselect w-full", {
                                                'is-invalid': _ctx.v$.information.classification.$error
                                            }])
                            }, null, 8, ["modelValue", "options", "class"]),
                            (_ctx.v$.information.classification.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_249, [
                                  (_ctx.v$.information.classification.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_250, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])),
                      (_ctx.information.securityCategory != '' && !_ctx.addInfo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_251, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbSecurityCategory, (dataValue, indexNum) => {
                              return (_openBlock(), _createElementBlock("div", { key: indexNum }, [
                                (_ctx.information.securityCategory == dataValue.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_252, [
                                      _cache[166] || (_cache[166] = _createElementVNode("label", { class: "controllabel" }, "Security Category", -1)),
                                      _createElementVNode("div", _hoisted_253, _toDisplayString(dataValue.key), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              (_ctx.addInfo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_254, [
                    _cache[167] || (_cache[167] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                    _createElementVNode("div", _hoisted_255, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["btnprimary mr-1.5", _ctx.disableStatusInfo ? 'btnprimary' : 'btndisabled pointer-events-none']),
                        onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.onCancelBtnInfo()))
                      }, "Reset", 2),
                      _createElementVNode("button", {
                        onClick: _cache[62] || (_cache[62] = ($event: any) => (_ctx.addInformationToObject())),
                        class: _normalizeClass(_ctx.disableStatusInfo ? 'btnprimary' : 'btndisabled pointer-events-none')
                      }, "Add", 2)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.addInformationObj.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_256))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addInformationObj, (info, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "px-4 flex flex-row justify-between",
                  key: info
                }, [
                  (_ctx.addInformationObj.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_257, [
                        _createElementVNode("div", _hoisted_258, [
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", _hoisted_259, _toDisplayString(info.information), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_260, [
                    _createElementVNode("button", {
                      class: "float-right",
                      onClick: ($event: any) => (_ctx.onInfoDelete(index))
                    }, _cache[168] || (_cache[168] = [
                      _createElementVNode("img", {
                        src: _imports_3,
                        class: "h-5 w-5 cursor-pointer"
                      }, null, -1)
                    ]), 8, _hoisted_261)
                  ])
                ]))
              }), 128))
            ]),
            (_ctx.addInformationObj.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_262, [
                  _createElementVNode("button", {
                    class: "btnprimary mr-1.5",
                    onClick: _cache[63] || (_cache[63] = ($event: any) => (_ctx.onResetBtnInfo(_ctx.information)))
                  }, "Reset"),
                  _createElementVNode("button", {
                    class: "btnprimary",
                    onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.saveInformation()))
                  }, "Save")
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.applyPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 3,
          class: "applyPopup",
          popUp: _ctx.applyPopup
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_263, [
              _createElementVNode("div", _hoisted_264, [
                _createElementVNode("div", _hoisted_265, [
                  _createElementVNode("div", _hoisted_266, [
                    (_ctx.thisScreen == 'Acceptance')
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_267, "Risk Accept"))
                      : _createCommentVNode("", true),
                    (_ctx.thisScreen == 'reset')
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_268, "Risk Reset"))
                      : _createCommentVNode("", true),
                    (_ctx.thisScreen == 'deactive')
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_269, "Risk Invalid"))
                      : _createCommentVNode("", true),
                    (_ctx.thisScreen == 'Avoid')
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_270, "Risk Avoid"))
                      : _createCommentVNode("", true),
                    (_ctx.thisScreen == 'Transfer')
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_271, "Risk Avoid"))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "p-1 ml-auto float-right text-3xl leading-none font-semibold outline-none focus:outline-none",
                      onClick: _cache[65] || (_cache[65] = ($event: any) => (_ctx.onClosebtnAction()))
                    }, _cache[169] || (_cache[169] = [
                      _createElementVNode("img", {
                        src: _imports_2,
                        class: "h-5 w-5 cursor-pointer"
                      }, null, -1)
                    ]))
                  ]),
                  _cache[172] || (_cache[172] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey ml-4 mr-4" }, null, -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_272, [
                      _createElementVNode("div", _hoisted_273, [
                        _createElementVNode("div", _hoisted_274, [
                          _createElementVNode("div", _hoisted_275, [
                            _cache[170] || (_cache[170] = _createElementVNode("label", { class: "controllabel" }, "Organization", -1)),
                            _createElementVNode("div", _hoisted_276, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainOrg, (org) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: org.value,
                                  class: "mr-2 mb-2 bg-primary text-white px-2 py-1 rounded"
                                }, _toDisplayString(_ctx.mappedOrgOptions.find(option => option.value === org.value)?.label || "-"), 1))
                              }), 128))
                            ])
                          ]),
                          _cache[171] || (_cache[171] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey upperspacing" }, null, -1)),
                          _createElementVNode("div", _hoisted_277, [
                            (_ctx.thisScreen == 'Acceptance')
                              ? (_openBlock(), _createElementBlock("label", _hoisted_278, "Reason for Accepting Risk / Justification"))
                              : _createCommentVNode("", true),
                            (_ctx.thisScreen == 'reset')
                              ? (_openBlock(), _createElementBlock("label", _hoisted_279, "Reason for Reset Risk / Justification"))
                              : _createCommentVNode("", true),
                            (_ctx.thisScreen == 'deactive')
                              ? (_openBlock(), _createElementBlock("label", _hoisted_280, "Reason for Delete Risk / Justification"))
                              : _createCommentVNode("", true),
                            (_ctx.thisScreen == 'Avoid')
                              ? (_openBlock(), _createElementBlock("label", _hoisted_281, "Reason for Avoid Risk"))
                              : _createCommentVNode("", true),
                            (_ctx.thisScreen == 'Transfer')
                              ? (_openBlock(), _createElementBlock("label", _hoisted_282, "Reason for Transfer Risk"))
                              : _createCommentVNode("", true),
                            _withDirectives(_createElementVNode("textarea", {
                              type: "text",
                              class: "inputboxstyling h-20 max-h-48",
                              "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.applyObj.comments) = $event)),
                              placeholder: "Reason / Justification"
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.applyObj.comments,
                                void 0,
                                { trim: true }
                              ]
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _cache[173] || (_cache[173] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey upperspacing" }, null, -1)),
              _createElementVNode("div", _hoisted_283, [
                _createElementVNode("button", {
                  disabled: _ctx.clickOnButton,
                  onClick: _cache[67] || (_cache[67] = ($event: any) => (_ctx.cancelAceeptResetBtn())),
                  class: _normalizeClass([_ctx.applyObj.comments == '' ? 'btndisabled pointer-events-none' : 'btnprimary', "mr-3"])
                }, "Reset", 10, _hoisted_284),
                (_ctx.thisScreen == 'Acceptance')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      disabled: _ctx.clickOnButton,
                      class: _normalizeClass(_ctx.applyObj.comments == '' ? 'btndisabled pointer-events-none' : 'btnprimary'),
                      onClick: _cache[68] || (_cache[68] = ($event: any) => (_ctx.createTaskForAction(_ctx.applyObj, 10403)))
                    }, "Apply", 10, _hoisted_285))
                  : _createCommentVNode("", true),
                (_ctx.thisScreen == 'Avoid')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      disabled: _ctx.clickOnButton,
                      class: _normalizeClass(_ctx.applyObj.comments == '' ? 'btndisabled pointer-events-none' : 'btnprimary'),
                      onClick: _cache[69] || (_cache[69] = ($event: any) => (_ctx.createTaskForAction(_ctx.applyObj, 10419)))
                    }, "Apply", 10, _hoisted_286))
                  : _createCommentVNode("", true),
                (_ctx.thisScreen == 'Transfer')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      disabled: _ctx.clickOnButton,
                      class: _normalizeClass(_ctx.applyObj.comments == '' ? 'btndisabled pointer-events-none' : 'btnprimary')
                    }, "Transfer", 10, _hoisted_287))
                  : _createCommentVNode("", true),
                (_ctx.thisScreen == 'reset')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 3,
                      disabled: _ctx.clickOnButton,
                      class: _normalizeClass([_ctx.applyObj.comments == '' ? 'btndisabled pointer-events-none' : 'btnprimary', "btnprimary"]),
                      onClick: _cache[70] || (_cache[70] = ($event: any) => (_ctx.createTaskForAction(_ctx.applyObj, 10407)))
                    }, "Apply", 10, _hoisted_288))
                  : _createCommentVNode("", true),
                (_ctx.thisScreen == 'deactive')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 4,
                      disabled: _ctx.clickOnButton,
                      class: _normalizeClass([_ctx.applyObj.comments == '' ? 'btndisabled pointer-events-none' : 'btnprimary', "btnprimary"]),
                      onClick: _cache[71] || (_cache[71] = ($event: any) => (_ctx.createTaskForAction(_ctx.applyObj, 10404)))
                    }, "Apply", 10, _hoisted_289))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.showPriorityPopUp)
      ? (_openBlock(), _createBlock(_component_popup, { key: 4 }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_290, [
              _cache[175] || (_cache[175] = _createElementVNode("h1", null, "Risk Prioritize", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[72] || (_cache[72] = ($event: any) => (_ctx.closePriorityPopup()))
              }, _cache[174] || (_cache[174] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_291, [
              _createElementVNode("div", _hoisted_292, [
                _createElementVNode("div", _hoisted_293, [
                  _cache[176] || (_cache[176] = _createElementVNode("label", {
                    class: "controllabel font-normal text-sm mb-1",
                    for: "vulnerability"
                  }, "Risk Name", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.riskPriorityShow.risk) = $event)),
                    disabled: "",
                    placeholder: "Name of the Risk",
                    id: "id",
                    class: _normalizeClass(["inputboxstyling", {
                                'is-invalid': _ctx.v$.riskPriorityShow.risk.$error
                            }])
                  }, null, 2), [
                    [
                      _vModelText,
                      _ctx.riskPriorityShow.risk,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (_ctx.v$.riskPriorityShow.risk.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_294, [
                        (_ctx.v$.riskPriorityShow.risk.required.$invalid)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_295, "Risk name is required"))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_296, [
                  _cache[177] || (_cache[177] = _createElementVNode("label", { class: "controllabel" }, "Priority", -1)),
                  _createVNode(_component_Select, {
                    modelValue: _ctx.riskPriorityShow.priority,
                    "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.riskPriorityShow.priority) = $event)),
                    options: _ctx.dbPriority,
                    optionLabel: "key",
                    optionValue: "value",
                    placeholder: "Priority",
                    class: "custom-multiselect w-full"
                  }, null, 8, ["modelValue", "options"])
                ]),
                (_ctx.v$.riskPriorityShow.priority.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_297, [
                      (_ctx.v$.riskPriorityShow.priority.required.$invalid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_298, "Please change priority"))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (this.riskPriorityShow.priority !== this.priorityDummy.priority)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_299, [
                      _createElementVNode("div", _hoisted_300, [
                        _createElementVNode("div", _hoisted_301, [
                          _cache[178] || (_cache[178] = _createElementVNode("label", {
                            for: "Risk",
                            class: "controllabel"
                          }, "Justification", -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            class: _normalizeClass(["inputboxstyling", {
                                        'is-invalid': _ctx.v$.riskPriorityShow.justification.$error
                                    }]),
                            placeholder: "Justification",
                            "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((_ctx.riskPriorityShow.justification) = $event))
                          }, null, 2), [
                            [
                              _vModelText,
                              _ctx.riskPriorityShow.justification,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ])
                      ]),
                      (_ctx.v$.riskPriorityShow.justification.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_302, [
                            (_ctx.v$.riskPriorityShow.justification.required.$invalid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_303, "Justification is required"))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _cache[179] || (_cache[179] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey ml-4 mr-4" }, null, -1)),
              _createElementVNode("div", _hoisted_304, [
                _createElementVNode("button", {
                  disabled: _ctx.clickOnButton,
                  class: _normalizeClass(["btnprimary mr-1.5", JSON.stringify(_ctx.riskPriorityShow) !== JSON.stringify(_ctx.priorityDummy) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                  onClick: _cache[76] || (_cache[76] = ($event: any) => (_ctx.cancelPriorityBtn()))
                }, "Reset", 10, _hoisted_305),
                _createElementVNode("button", {
                  disabled: _ctx.clickOnButton,
                  onClick: _cache[77] || (_cache[77] = ($event: any) => (_ctx.addOrUpdatePriority())),
                  class: _normalizeClass(JSON.stringify(_ctx.riskPriorityShow) !== JSON.stringify(_ctx.priorityDummy) ? 'btnprimary' : 'btndisabled pointer-events-none')
                }, "Save", 10, _hoisted_306)
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}